import type { ListMerchants } from '@cloudFunctions/types/payments/listMerchants';
import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-776 (Phase 5 Sub-phase 1). The
 * cloudFunctions callable was retired in S9-WB2 (PRA-804); the type-only
 * `ListMerchants` namespace at the import path above remains the
 * canonical wire contract.
 */
export const listMerchantsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/merchants:lookup',
  body: (requestData: ListMerchants.RequestData) => requestData,
} as const satisfies BackendRouteDefinition;
